import {
  JURIK_ERID_COOKIE_NAME,
  JURIK_ERID_COOKIE_MAX_AGE,
} from '@/shared/constants/cookiesConstants';
import { ROOT_HELPER_URL } from '@/shared/constants/urlConstants';

export default defineNuxtRouteMiddleware((to) => {
  const erid = to.query.erid;
  if (!erid) return;

  const eridCookie = useCookie<string>(JURIK_ERID_COOKIE_NAME, {
    path: '/',
    maxAge: JURIK_ERID_COOKIE_MAX_AGE,
  });
  eridCookie.value = String(erid);

  const query: Record<string, string> = {};
  if (to.query.token) query.token = String(to.query.token);
  if (to.query.intent) query.intent = String(to.query.intent);

  return navigateTo({ path: ROOT_HELPER_URL, query }, { redirectCode: 302 });
});
